import React, { Fragment } from "react";
import { Divider, styled, ListSubheader, Typography } from "@material-ui/core";
import {
  Activity,
  BillActivity,
  CreditActivity,
  ManualBillActivity,
  FINANCIAL_ACTIVITY_TYPES,
  FinancialActivity,
  NoteActivity,
  DemandActivity,
  CommunicationActivity,
  AgreementActivity,
  TicketActivity,
} from "../../../api/services";
import { TicketActivityItem } from "./TicketActivityItem";
import { BillActivityItem } from "./BillActivityItem";
import { CreditActivityItem } from "./CreditActivityItem";
import { DemandActivityItem } from "./DemandActivityItem";
import { ManualBillActivityItem } from "./ManualBillActivityItem";
import { FinancialActivityItem } from "./FinancialActivityItem";
import { NoteActivityItem } from "./NoteActivityItem";
import { CommActivityItem } from "./CommActivityItem";
import { AgreementActivityItem } from "./AgreementActivityItem";
import { isPending } from "../hooks/useActivityGroups";

const createActivityItem = (activity: Activity) => {
  const { type } = activity;
  switch (type) {
    case "Ticket":
      return <TicketActivityItem activity={activity as TicketActivity} />;
    case "Bill":
      return <BillActivityItem activity={activity as BillActivity} />;
    case "Credit":
      return <CreditActivityItem activity={activity as CreditActivity} />;
    case "ManualBill":
      return (
        <ManualBillActivityItem activity={activity as ManualBillActivity} />
      );
    case "Note":
      return <NoteActivityItem activity={activity as NoteActivity} />;
    case "WrapUpNote":
      return <DemandActivityItem activity={activity as DemandActivity} />;
    case "Communication":
      return <CommActivityItem activity={activity as CommunicationActivity} />;
    case "Agreement":
      return <AgreementActivityItem activity={activity as AgreementActivity} />;
    default:
      if (FINANCIAL_ACTIVITY_TYPES.includes(type)) {
        return (
          <FinancialActivityItem activity={activity as FinancialActivity} />
        );
      }
      return null;
  }
};
const StyledListHeader = styled(ListSubheader)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  lineHeight: theme.spacing(4) + "px",
})) as typeof ListSubheader;

const StyledHeaderText = styled(Typography)(() => ({
  fontWeight: "bold",
}));

export const ActivityGroupHeader: React.FC<{ isPending?: boolean }> = ({
  isPending,
  children,
}) => (
  <StyledListHeader data-testid="ActivityPanel__ListSubheader" component="div">
    <StyledHeaderText
      variant="caption"
      color={isPending ? "textSecondary" : "textPrimary"}
      gutterBottom={false}
    >
      {children}
    </StyledHeaderText>
  </StyledListHeader>
);

export const ActivityGroup: React.FC<{
  header: string;
  activities: Activity[];
}> = ({ header, activities }) => {
  return (
    <>
      <ActivityGroupHeader isPending={isPending(header)}>
        {header}
      </ActivityGroupHeader>
      {activities.map((activity) => {
        const item = createActivityItem(activity);
        return (
          item && (
            <Fragment key={`activity:${activity.type}:${activity.id}`}>
              <Divider />
              {item}
            </Fragment>
          )
        );
      })}
    </>
  );
};
